module.exports = __webpack_public_path__ + "img/avatar-s-11.1df2eb3a.jpg";